// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sjT_","questions":"styles_questions__18zbJ","footer":"styles_footer__2wgH-"};